<template>
  <b-container fluid id="tables">
    <b-row
      style="display: flex; justify-content: space-between; width: 100%; text-align: center; padding: 10px;"
    >
      <div class="col-2">
        <input
          class="form-control ShifokrSverka"
          type="date"
          v-model="datas.date1"
        />
      </div>
      <div class="col-2">
        <input
          class="form-control ShifokrSverka"
          type="date"
          v-model="datas.date2"
        />
      </div>
      <div style="display: flex;">
        <b-form-checkbox
          style="display: flex; width: 100px;"
          v-model="datas.type"
          :value="0"
          :unchecked-value="1"
        >
          Ҳодим
        </b-form-checkbox>
        <button
          type="button"
          class="btn text-white"
          style="background: #195FB0; width: 130px; font-size: 14px"
          @click="Send()"
        >
          <img
            src="../../../public/Vector.png"
            alt=""
            style="margin-right: 5px"
          />
          {{ $t("Кўриш") }}
        </button>
        <button
          class="btn text-white"
          style="background: #195FB0; width: 130px; margin-left: 10px; font-size: 14px"
          @click="downloadExl"
        >
          Юклаш
        </button>
        <!-- <button @click="downloadTable">Download Table as Excel</button> -->
      </div>
      <div>
        <b-button variant="danger" @click="cancel()">
          <b-icon icon="x-circle-fill"></b-icon>
        </b-button>
      </div>
    </b-row>
    <div id="table-container">
      <div class="tableId">
        <table
          id="my-table"
          class="table  table-bordered table-sm table-striped"
        >
          <tr class="bg-dark text-white">
            <th style="width: 30px !important" rowspan="2">#</th>
            <th rowspan="2" style="width: 350px;">{{ $t("Ф.И.Ш") }}</th>
            <th colspan="3">{{ $t("Операция") }}</th>
            <th colspan="3">{{ $t("Шифокор") }}</th>
            <th colspan="3">{{ "Текширув" }}</th>
            <th colspan="3">{{ "Plata" }}</th>
            <th colspan="3">{{ "Стационар дори дармон" }}</th>
            <th colspan="2">{{ "Жами кирим" }}</th>
            <th rowspan="2">{{ $t("Скидка") }}</th>
            <th rowspan="2">{{ "Расход UZS" }}</th>
            <th rowspan="2">{{ "Расход USD" }}</th>
            <!-- <th rowspan="2">{{ "Текширувлар сони" }}</th> -->
          </tr>
          <tr>
            <th>{{ "Сони" }}</th>
            <th>{{ "Ҳодим" }}</th>
            <th>{{ "Клиника" }}</th>

            <th>{{ "Сони" }}</th>
            <th>{{ "Ҳодим" }}</th>
            <th>{{ "Клиника" }}</th>

            <th>{{ "Сони" }}</th>
            <th>{{ "Ҳодим" }}</th>
            <th>{{ "Клиника" }}</th>

            <th>{{ "Сони" }}</th>
            <th>{{ "Ҳодим" }}</th>
            <th>{{ "Клиника" }}</th>

            <th>{{ "Сони" }}</th>
            <th>{{ "Ҳодим" }}</th>
            <th>{{ "Клиника" }}</th>

            <th>{{ "Ҳодим" }}</th>
            <th>{{ "Клиника" }}</th>
          </tr>
          <tr
            v-for="(item, index) in results"
            :key="index"
            v-on:dblclick="Router(item)"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ item.user_name }}</td>

            <td>{{ item.operatsiya ? item.operatsiya : '' }}</td>
            <td>{{ item.kirim_surgery_user | numFormat }}</td>
            <td>{{ item.kirim_surgery | numFormat }}</td>

            <td>{{ item.korik ? item.korik : '' }}</td>
            <td>{{ item.kirim_korik_user | numFormat }}</td>
            <td>{{ item.kirim_korik | numFormat }}</td>

            <td>{{ item.tekshiruv ? item.tekshiruv : '' }}</td>
            <td>{{ item.kirim_ins_user | numFormat }}</td>
            <td>{{ item.kirim_ins | numFormat }}</td>

            <td>{{ item.palata_count ? item.palata_count : '' }}</td>
            <td>{{ item.kirim_palata_user | numFormat }}</td>
            <td>{{ item.kirim_palata | numFormat }}</td>

            <td>{{ item.reagent_count ? item.reagent_count : '' }}</td>
            <td>{{ item.kirim_reag_user | numFormat }}</td>
            <td>{{ item.kirim_reag | numFormat }}</td>

            <td>{{ item.kirim_clinic_user | numFormat }}</td>
            <td>{{ item.kirim_clinic | numFormat }}</td>

            <td>{{ item.reg_discount | numFormat }}</td>
            <td>{{ item.uzs_rasxod | numFormat }}</td>
            <td>{{ item.usd_rasxod | numFormat }}</td>
          </tr>
          <!-- <tbody style="position: sticky; bottom: 1px; z-index: 1; background: #fff;">
              <tr>
                <td colspan="6">{{ $t("Жами") }}</td>
                <td>
                  {{  }}
                </td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t("Жами кирим") }} {{  }}</td>
                <td>{{ $t("Жами чиқим") }} {{  }}</td>
              </tr>
            </tbody> -->
        </table>
      </div>
    </div>
  </b-container>
</template>

<script>
import moment from "moment";
var XLSX = require("xlsx");
var FileSaver = require("file-saver");
// import XLSX from 'xlsx';
// import { read, writeFileXLSX } from "./xlsx.mjs";
// import { set_cptable } from "./xlsx.mjs";
// import * as cptable from './dist/cpexcel.full.mjs';
// set_cptable(cptable);
export default {
  data() {
    return {
      datas: {
        date1: null,
        date2: null,
        type: 0
      },
      results: {},
      names: [],
      localUser: JSON.parse(localStorage.getItem("user"))
    };
  },
  filters: {
    dateFormatDD: function(date) {
      if (date != null) {
        return moment.unix(date).format("DD.MM.YYYY HH:mm");
      } else {
        return "";
      }
    }
  },
  created() {
    let self = this;
    if (JSON.parse(localStorage.getItem("datas")) == null) {
      self.datas.date1 = new Date().toISOString().slice(0, 10);
      self.datas.date2 = new Date().toISOString().slice(0, 10);
    } else {
      self.datas.date1 = JSON.parse(localStorage.getItem("datas")).date1;
      self.datas.date2 = JSON.parse(localStorage.getItem("datas")).date2;
      localStorage.removeItem("datas");
    }
  },

  methods: {
    Send() {
      let self = this;
      var datas = {
        datetime1: new Date(self.datas.date1).setHours(0, 0, 0) / 1000,
        datetime2: new Date(self.datas.date2).setHours(23, 59, 0) / 1000,
        type: self.datas.type
      };
      axios({
        method: "post",
        url: "hisobot/hodim-kassa-hsobot",
        data: datas
      }).then(res => {
        if (res) {
          self.results = res.data.items;
        }
      });
    },
    cancel() {
      window.close();
    },
    Router(item) {
      if (item.doc_type === "Kirim" && this.datas.date1 <= this.datas.date2) {
        // this.$router.push({path: '/arxivone/' + item.doctor_id})
        let route = this.$router.resolve({
          path: "/arxivone/" + item.doctor_id
        });
        window.open(route.href, "_blank");
      } else if (item.place == "supplier") {
        let route = this.$router.resolve({
          path: "/provider/pay/update/" + item.doctor_id
        });
        window.open(route.href, "_blank");
      } else if (
        (item.pay_type === "naqt" || item.pay_type === "plastik") &&
        this.datas.date1 <= this.datas.date2
      ) {
        // this.$router.push({path: 'KassaDoc/' + item.doctor_id})
        let route = this.$router.resolve({
          path: "KassaDoc/" + item.doctor_id
        });
        window.open(route.href, "_blank");
      } else if (this.datas.date1 <= this.datas.date2) {
        // this.$router.push({path: 'oplataDoc/' + item.doctor_id})
        let route = this.$router.resolve({
          path: "oplataDoc/" + item.doctor_id
        });
        window.open(route.href, "_blank");
      }
    },
    tableToSheetData(table) {
      const rows = table.querySelectorAll("tr");
      const data = [];

      for (const row of rows) {
        const rowData = [];
        const cells = row.querySelectorAll("td, th");

        for (const cell of cells) {
          rowData.push(cell.innerText);
        }

        data.push(rowData);
      }

      return data;
    },
    downloadExl() {
      let wb = XLSX.utils.table_to_book(document.getElementById("my-table")),
        wopts = {
          bookType: "xlsx",
          bookSST: false,
          type: "binary"
        };
      var wscols = [
        { width: 5 },
        { width: 55 },
        { width: 10 },
        { width: 13 },
        { width: 13 },
        { width: 10 },
        { width: 13 },
        { width: 13 },
        { width: 10 },
        { width: 13 },
        { width: 13 },
        { width: 10 },
        { width: 13 },
        { width: 13 },
        { width: 10 },
        { width: 13 },
        { width: 13 },
        { width: 13 },
        { width: 13 }
      ];
      wb.Sheets.Sheet1["!cols"] = wscols;
      let wbout = XLSX.write(wb, wopts);
      const currentDate = new Date();

      const day = currentDate
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 because months are zero-based
      const year = currentDate.getFullYear().toString();
      const hours = currentDate
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = currentDate
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
      FileSaver.saveAs(
        new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream;charset=utf-8"
        }),
        formattedDate + "_hodim_kassa_xisobot.xlsx"
      );
    },
    // async downloadTable() {
    //     try {
    //         // Dynamically load XLSX module
    //         const XLSX = await import(/* webpackChunkName: "xlsx" */ 'xlsx');

    //         const tableContainer = document.getElementById('table-container');
    //         const table = document.getElementById('my-table');
    //         const sheetData = this.tableToSheetData(table);

    //         const workbook = XLSX.utils.book_new();
    //         const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    //         XLSX.utils.book_append_sheet(workbook, worksheet, 'Table Data');

    //         const excelData = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

    //         const date = new Date().toISOString().slice(0, 19).replace(/[-T]/g, "");
    //         const fileName = `table_data_${date}.xlsx`;
    //         const blob = new Blob([this.s2ab(excelData)], { type: 'application/octet-stream' });

    //         if (navigator.msSaveBlob) {
    //             navigator.msSaveBlob(blob, fileName);
    //         } else {
    //             const link = document.createElement('a');
    //             link.href = URL.createObjectURL(blob);
    //             link.download = fileName;
    //             link.click();
    //         }
    //     } catch (error) {
    //         console.error('Error loading XLSX module:', error);
    //     }
    // },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
  },
  mounted() {
    // this.getKassa();
  }
};
</script>

<style scoped>
.reds {
  color: red;
}
.tablesD {
  /* overflow-y: scroll; */
  /* overflow-x: hidden; */
  /* height: 395px; */
  width: 100%;
}
#y1 {
  width: 80px !important;
}
table {
  margin: 0px;
}
label,
td,
th,
tr {
  font-family: "Times New Roman", Times, serif;
  font-weight: bolder;
  text-transform: capitalize;
  font-size: 15px;
  height: 30px !important;
}
.ShifokrSverka {
  border-radius: 3px;
  background: #fff;
  border: 1px solid rgb(210, 210, 210);
}
.reds {
  color: red;
}
#tables {
  text-align: center;
  width: 99% !important;
  height: 100vh !important;
}
th {
  color: #195fb0;
  background-color: #f4f7fb;
}
</style>
